import Http from './http';
import store from 'store';

class RegulatorsService {
    constructor() {
        this.regulators = null;
    }

    resetCache(){
        if (!this.regulators) return;
        store.set('regulators', false)
        this.regulators = null;
        this.getRegulators()
    }

    getRegulators() {
        return new Promise((resolve, reject) => {
            if (store.get('regulators', false)){
                this.regulators = store.get('regulators');
            }
            if (this.regulators) resolve(this.regulators);
            else {
                Http.get('/regulator-selector/').then(resp => {
                    this.regulators = resp.data;
                    store.set('regulators', this.regulators)
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new RegulatorsService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/regulators.js